import request from '@/utils/request.js';
import Qs from 'qs';

/**
 * 用户权限认证服务
 */
 export class AuthenticationControllerSvr {
    constructor() {
        this.baseurl = 'AuthenticationControllerSvr.assx/';
    }

    /**
     * 获取用户信息
     * token:String
     */
    getUserRole(token){
        return request.post(this.baseurl + 'getUserRole', Qs.stringify({ token:token }));
    }

    /**
     * 用户登出
     * token:String
     */
    logout(token){
        return request.post(this.baseurl + 'logout', Qs.stringify({ token:token }));
    }

    /**
     * 用户登录
     * loginId:String, passWord:String, verfCode:String
     */
    loginWithCode(loginId, passWord, verfCode){
        return request.post(this.baseurl + 'loginWithCode', Qs.stringify({ loginId:loginId, passWord:passWord, verfCode:verfCode }));
    }

    /**
     * 获取用户信息
     * token:String, option:int
     */
    getUserDetail(token, option){
        return request.post(this.baseurl + 'getUserDetail', Qs.stringify({ token:token, option:option }));
    }

    /**
     * 获取用户信息
     * token:String, roleId:String
     */
    getUserDetailForRole(token, roleId){
        return request.post(this.baseurl + 'getUserDetailForRole', Qs.stringify({ token:token, roleId:roleId }));
    }

    /**
     * 用户登录
     * loginId:String, passWord:String
     */
    login(loginId, passWord){
        return request.post(this.baseurl + 'login', Qs.stringify({ loginId:loginId, passWord:passWord }));
    }

    /**
     * 链接登录
     * skipKeySN:String, skipKeyID:String
     */
    SimpleLogin(skipKeySN, skipKeyID){
        return request.post(this.baseurl + 'SimpleLogin', Qs.stringify({ skipKeySN:skipKeySN, skipKeyID:skipKeyID }));
    }

    /**
     * 修改密码
     * token:String, oldPwd:String, newPwd:String
     */
    changePassword(token, oldPwd, newPwd){
        return request.post(this.baseurl + 'changePassword', Qs.stringify({ token:token, oldPwd:oldPwd, newPwd:newPwd }));
    }
}